import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\dev\\anton\\12-25-anton - Copie - Copie - Copie\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\dev\\anton\\12-25-anton - Copie - Copie - Copie\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\dev\\anton\\12-25-anton - Copie - Copie - Copie\\src\\app\\ui\\client\\bg\\star-shoot\\index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\dev\\anton\\12-25-anton - Copie - Copie - Copie\\src\\app\\ui\\CookieBanner.jsx");
;
import(/* webpackMode: "eager" */ "C:\\dev\\anton\\12-25-anton - Copie - Copie - Copie\\src\\app\\ui\\layout\\Footer\\styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\dev\\anton\\12-25-anton - Copie - Copie - Copie\\src\\app\\ui\\layout\\navbar\\index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\dev\\anton\\12-25-anton - Copie - Copie - Copie\\src\\app\\ui\\layout\\Remounted.jsx");
